export const SET_CURRENT_EVENT_LANGUAGE = 'SET_CURRENT_EVENT_LANGUAGE';


export const setCurrentEventLanguage = (language) => {
    return {
        type: SET_CURRENT_EVENT_LANGUAGE,
        payload: language
    }
}